import React, { useState } from 'react';
import { Eye, EyeOff, Lock, Mail } from 'lucide-react';
import { COLORS } from '../../constants/theme';

const VALID_EMAIL = 'admin@example.com';
const VALID_PASSWORD = 'password@123';

const LoginScreen = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim().toLowerCase() === VALID_EMAIL && password === VALID_PASSWORD) {
      onLoginSuccess({
        email: VALID_EMAIL,
      });
      return;
    }
    setError('Invalid email or password.');
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8 bg-slate-100">
      <div className="w-full max-w-5xl grid lg:grid-cols-2 bg-white rounded-3xl shadow-2xl border border-slate-200 overflow-hidden">
        <div
          className="hidden lg:flex flex-col justify-between gap-8 px-8 py-10 text-white"
          style={{ background: `linear-gradient(155deg, ${COLORS.secondary}, ${COLORS.primary})` }}
        >
          <div>
            <h2 className="text-3xl font-bold leading-tight">
              AI-powered procurement intelligence at your fingertips.
            </h2>
            <p className="text-sm text-white/90 mt-4 max-w-md">
              Upload any Excel file, ask questions in plain English, and get instant spend analysis, vendor insights, and cost-centre breakdowns.
            </p>
          </div>
          <div className="rounded-2xl border border-white/20 bg-white/10 p-4 backdrop-blur-sm">
            <p className="text-xs font-semibold uppercase tracking-wider text-white/90">What you can do</p>
            <div className="mt-3 grid grid-cols-2 gap-3 text-xs text-white/90">
              <div className="rounded-lg bg-white/10 px-3 py-2">Spend tracking</div>
              <div className="rounded-lg bg-white/10 px-3 py-2">Vendor insights</div>
              <div className="rounded-lg bg-white/10 px-3 py-2">Cost centres</div>
              <div className="rounded-lg bg-white/10 px-3 py-2">Natural language Q&A</div>
            </div>
          </div>
        </div>

        <div className="px-6 sm:px-8 py-8 sm:py-10">
          {/* <div className="mb-6 lg:hidden">
            <div className="bg-slate-50 border border-slate-200 rounded-xl p-2 inline-block">
              <img
                src={contisoftLogo}
                alt="Contisoft Technologies"
                className="h-9 sm:h-10 w-auto"
              />
            </div>
          </div> */}
          <h1 className="text-2xl font-bold text-slate-900">Sign in to Procurement Agent</h1>
          <p className="text-sm text-slate-500 mt-1">
            Use your credentials to access the procurement dashboard.
          </p>
          <div className="mt-4 bg-slate-50 border border-slate-200 rounded-xl px-3 py-3">
            <p className="text-xs font-semibold text-slate-700 mb-1">Demo Credentials</p>
            <p className="text-xs text-slate-600">
              <span className="font-medium">Email:</span> admin@example.com
            </p>
            <p className="text-xs text-slate-600 mt-0.5">
              <span className="font-medium">Password:</span> password@123
            </p>
          </div>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
              <div className="relative">
                <Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  placeholder="Enter email"
                  className="w-full pl-9 pr-3 py-2.5 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:border-transparent"
                  style={{ '--tw-ring-color': `${COLORS.primary}40` }}
                  required
                />
              </div>
            </div>

            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
              <div className="relative">
                <Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError('');
                  }}
                  placeholder="Enter password"
                  className="w-full pl-9 pr-10 py-2.5 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:border-transparent"
                  style={{ '--tw-ring-color': `${COLORS.primary}40` }}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700"
                  aria-label="Toggle password visibility"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {error && (
              <div className="text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-lg px-3 py-2">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="w-full text-white font-semibold py-2.5 rounded-xl transition hover:opacity-95"
              style={{ backgroundColor: COLORS.primary }}
            >
              Login to Continue
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
